export default __webpack_public_path__ + "static/media/WelcomeView_4-min.0ce49489.png";